const data = {
  Token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Imp1bGlvIiwibmJmIjoxNjM1NDA1MDczLCJleHAiOjE2MzU0MDY4NzMsImlhdCI6MTYzNTQwNTA3MywiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo0OTIyMCIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6NDkyMjAifQ.iaq4LkByZZS6rMAoPmuiY0f6mGW_jehy4ze6oZ5qPvU',
  blnError: false,
  codError: null,
  msgError: null
}

export default data
